import { Link, useSearchParams } from "react-router";

import { PennText } from "@/components/ui";
import { Cad3dPanel } from "@/components/cad3d/Cad3dPanel";
import { useAppSelector } from "@/stores/hooks";

// Single-preview / testing screen: upload a STEP file and preview the generated
// GLB. Available to all users. The side-by-side similarity comparison lives on
// its own internal-only screen (/cad/compare). Reads ?applicationId=<uuid>.
export const StepCheckPage = () => {
  const [params] = useSearchParams();
  const applicationId = params.get("applicationId");
  // Effective isInternal (user AND role) — see ComparePage.tsx's comment;
  // this only decides whether to SHOW the link to that page.
  const isInternal = useAppSelector(
    (s) => (s.auth.user?.isInternal && s.auth.user?.role?.isInternal) ?? false,
  );

  return (
    <div className="mx-auto max-w-5xl px-4 py-8">
      <div className="mb-6 flex items-end justify-between gap-3">
        <div>
          <PennText as="h1" className="text-h1" color="on-navy">
            3D part check
          </PennText>
          <PennText as="p" size="base" color="on-navy-secondary" className="mt-1">
            Upload a STEP file for your application and preview the generated 3D model.
          </PennText>
        </div>
        {isInternal && applicationId && (
          <Link
            to={`/cad/compare?applicationId=${encodeURIComponent(applicationId)}`}
            className="text-button text-penn-100 hover:text-white hover:underline"
          >
            Open comparison →
          </Link>
        )}
      </div>

      {applicationId ? (
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-soft">
          <Cad3dPanel
            applicationId={applicationId}
            viewerHeight={460}
            showOpenViewerLink={false}
          />
        </div>
      ) : (
        <div className="rounded-2xl border border-dashed border-white/30 p-8 text-center">
          <PennText as="p" size="base" color="on-navy-secondary">
            No application selected. Open this page from an application to upload and
            view its 3D part.
          </PennText>
          <Link
            to="/installation-system"
            className="mt-3 inline-block text-button text-penn-100 hover:text-white hover:underline"
          >
            Go to applications →
          </Link>
        </div>
      )}
    </div>
  );
};
